import { useQuery } from '@tanstack/react-query';
import api from '../../http';
import type { FertilizationPlanReferenceDTO } from './types';

export const useGetFertilizationPlanReferences = ({ enabled = true }: { enabled?: boolean } = {}) =>
	useQuery<FertilizationPlanReferenceDTO[]>({
		queryKey: ['fertilization-plan-reference', 'list'],
		enabled,
		queryFn: async () => {
			const { data } = await api.get<FertilizationPlanReferenceDTO[]>('/fertilization-plan-reference/findAll');
			return data;
		},
	});
